import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function PageHero({ overline, title, subtitle, bgImage }) {
  return (
    <Box
      sx={{
        pt: { xs: "86px", md: "94px" },
        width: "100%",
        backgroundColor: "#0D1117",
        ...(bgImage && {
          backgroundImage: `linear-gradient(rgba(7,9,18,0.62), rgba(7,9,18,0.72)), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }),
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 5 },
          py: { xs: 7, md: 9 },
          maxWidth: 1440,
          mx: "auto",
        }}
      >
        {overline && (
          <Typography
            variant="overline"
            sx={{ letterSpacing: 2, color: "#FF6A00", fontWeight: 700 }}
          >
            {overline}
          </Typography>
        )}
        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            mt: overline ? 1 : 0,
            fontWeight: 800,
            fontSize: { xs: "2rem", md: "2.6rem" },
            lineHeight: 1.1,
            maxWidth: 680,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              color: "rgba(245,247,255,0.72)",
              mt: 2,
              maxWidth: 560,
              lineHeight: 1.7,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
